import api from '../index'

/**
 * @param {object} data 传参
 * @description 文件列表
 * @returns {Promise} 请求结果
 */
export function reqKnowledgeIndex(data: any) {
  return api.post('/common/knowledgeFiles/index', data)
}
/**
 * @param {object} data 传参
 * @description 课程列表
 * @returns {Promise} 请求结果
 */
export function reqKnowledgeCoursesIndex(data: any) {
  return api.post('/common/courses/index', data)
}
/**
 * @param {object} data 传参
 * @description 课程详情
 * @returns {Promise} 请求结果
 */
export function reqKnowledgeCoursesDetail(data: any) {
  return api.post('/common/courses/detail', data)
}
/**
 * @param {object} data 传参
 * @description 课程知识点
 * @returns {Promise} 请求结果
 */
export function reqKnowledgeCoursesTree(data: any) {
  return api.post('/common/courseKnowledge/tree', data)
}
/**
 * @param {object} data 传参
 * @description 文件列表
 * @returns {Promise} 请求结果
 */
export function reqKnowledgeCourseFilesList(data: any) {
  return api.post('/common/knowledgeFiles/index', data)
}
/**
 * @param {object} data 传参
 * @description 文件详情
 * @returns {Promise} 请求结果
 */
export function reqKnowledgeCourseFilesDetail(data: any) {
  return api.post('/common/knowledgeFiles/detail', data)
}
/**
 * @param {object} data 传参
 * @description 删除文件
 * @returns {Promise} 请求结果
 */
export function reqKnowledgeCourseFilesDelete(data: any) {
  return api.post('/common/knowledgeFiles/delete', data)
}
/**
 * @param {object} data 传参
 * @description 上传知识库
 * @returns {Promise} 请求结果
 */
export function reqKnowledgeCourseFilesCreate(data: any) {
  return api.post('/common/knowledgeFiles/create', data)
}
/**
 * @param {object} data 传参
 * @description 共享知识库
 * @returns {Promise} 请求结果
 */
export function reqKnowledgeCourseFilesShare(data: any) {
  return api.post('/common/knowledgeFiles/share', data)
}
/**
 * @param {object} data 传参
 * @description 微调模型
 * @returns {Promise} 请求结果
 */
export function reqKnowledgeFilesFineTune(data: any) {
  return api.post('/common/knowledgeFiles/fineTune', data)
}
/**
 * @param {object} data 传参
 * @description 查询微调任务状态
 * @returns {Promise} 请求结果
 */
export function reqKnowledgeFilesFineTuneStatus(data: any) {
  return api.post('/common/knowledgeFiles/fineTuneStatus', data)
}
/**
 * @param {object} data 传参
 * @description 获取微调任务列表
 * @returns {Promise} 请求结果
 */
export function reqKnowledgeFilesFineTuneTasks(data: any) {
  return api.post('/common/knowledgeFiles/fineTuneTasks', data)
}
/**
 * @param {object} data 传参
 * @description 生成习题
 * @returns {Promise} 请求结果
 */
export function reqCreateExerciseTask(data: any) {
  return api.post('/teacher/courseTestPapers/createExerciseTask', data)
}
/**
 * @param {object} data 传参
 * @description 生成习题结果
 * @returns {Promise} 请求结果
 */
export function reqExerciseTaskDetail(data: any) {
  return api.post('/teacher/courseTestPapers/exerciseTaskDetail', data)
}
/**
 * @param {object} data 传参
 * @description 习题列表
 * @returns {Promise} 请求结果
 */
export function reqExerciseTaskIndex(data: any) {
  return api.post('/teacher/courseTestPapers/index', data)
}

/**
 * @param {object} data 传参
 * @description 新增习题（生成习题后新增）
 * @returns {Promise} 请求结果
 */
export function reqExerciseTaskCreate(data: any) {
  return api.post('/teacher/courseTestPapers/create', data)
}
/**
 * @param {object} data 传参
 * @description 发布习题（导入习题后发布）
 * @returns {Promise} 请求结果
 */
export function reqExerciseTaskRelease(data: any) {
  return api.post('/teacher/courseTestPapers/release', data)
}
/**
 * @param {object} data 传参
 * @description 导入习题
 * @returns {Promise} 请求结果
 */
export function reqExerciseTaskImport(data: any) {
  return api.post('/teacher/courseTestPapers/import', data, { headers: { 'Content-Type': 'multipart/form-data' } })
}
/**
 * @param {object} data 传参
 * @description 知识图谱
 * @returns {Promise} 请求结果
 */
export function reqKnowledgeChart(data: any) {
  return api.post('/common/courses/knowledgeChart', data)
}
/**
 * @param {object} data 传参
 * @description 学生列表
 * @returns {Promise} 请求结果
 */
export function reqTeacherStudentList(data: any) {
  return api.post('/teacher/students/index', data)
}
/**
 * @param {object} data 传参
 * @description 学生学院专业等选项
 * @returns {Promise} 请求结果
 */
export function reqTeacherStudentOptions(data?: any) {
  return api.post('/teacher/students/options', data)
}
/**
 * @param {object} data 传参
 * @description 习题统计
 * @returns {Promise} 请求结果
 */
export function reqTestPaperStatistics(data?: any) {
  return api.post('/common/testPaperStatistics/index', data)
}
/**
 * @param {object} data 传参
 * @description 课程评价统计
 * @returns {Promise} 请求结果
 */
export function reqCourseEvaluatesStatistics(data?: any) {
  return api.post('/teacher/courseEvaluates/statistics', data)
}
/**
 * @param {object} data 传参
 * @description 课程评价列表
 * @returns {Promise} 请求结果
 */
export function reqCourseEvaluatesList(data?: any) {
  return api.post('/teacher/courseEvaluates/index', data)
}
/**
 * @param {object} data 传参
 * @description 删除课程评价
 * @returns {Promise} 请求结果
 */
export function reqCourseEvaluatesDelete(data?: any) {
  return api.post('/teacher/courseEvaluates/delete', data)
}
/**
 * @param {object} data 传参
 * @description 批量删除课程评价
 * @returns {Promise} 请求结果
 */
export function reqCourseEvaluatesBatchDelete(data?: any) {
  return api.post('/teacher/courseEvaluates/batchDelete', data)
}
/**
 * @param {object} data 传参
 * @description 习题详情(用户填写的)
 * @returns {Promise} 请求结果
 */
export function reqUserTestPapersDetail(data?: any) {
  return api.post('/common/userTestPapers/detail', data)
}
/**
 * @param {object} data 传参
 * @description 习题详情
 * @returns {Promise} 请求结果
 */
export function reqCourseTestPapersDetail(data?: any) {
  return api.post('/common/courseTestPapers/detail', data)
}
/**
 * @param {object} data 传参
 * @description 提交习题
 * @returns {Promise} 请求结果
 */
export function reqUserTestPapersSubmit(data?: any) {
  return api.post('/common/userTestPapers/submit', data)
}
/**
 * @param {object} data 传参
 * @description 生成课件
 * @returns {Promise} 请求结果
 */
export function reqLessonPreparationCreate(data?: any) {
  return api.post('/teacher/lessonPreparation/create', data)
}
/**
 * @param {object} data 传参
 * @description 教师班级列表
 * @returns {Promise} 请求结果
 */
export function reqTeacherClassesList(data?: any) {
  return api.post('/common/classes/teacherIndex', data)
}
/**
 * @param {object} data 传参
 * @description 删除班级
 * @returns {Promise} 请求结果
 */
export function reqTeacherClassesDelete(data?: any) {
  return api.post('/common/classes/delete', data)
}
/**
 * @param {object} data 传参
 * @description 新增班级
 * @returns {Promise} 请求结果
 */
export function reqTeacherClassesCreate(data?: any) {
  return api.post('/common/classes/create', data)
}
/**
 * @param {object} data 传参
 * @description 编辑班级
 * @returns {Promise} 请求结果
 */
export function reqTeacherClassesUpdate(data?: any) {
  return api.post('/common/classes/update', data)
}
/**
 * @param {object} data 传参
 * @description 导出学生列表
 * @returns {Promise} 请求结果
 */
export function reqTeacherStudentExport(data?: any) {
  return api.post('/teacher/students/export', data, { responseType: 'blob' })
}
/**
 * @param {object} data 传参
 * @description 成绩列表
 * @returns {Promise} 请求结果
 */
export function reqTestPaperStatisticsScoreIndex(data?: any) {
  return api.post('/common/testPaperStatistics/scoreIndex', data)
}
/**
 * @param {object} data 传参
 * @description 导出成绩列表
 * @returns {Promise} 请求结果
 */
export function reqTestPaperStatisticsScoreExport(data?: any) {
  return api.post('/common/testPaperStatistics/exportScoreIndex', data, { responseType: 'blob' })
}
/**
 * @param {object} data 传参
 * @description 学生错题统计
 * @returns {Promise} 请求结果
 */
export function reqStudentDataErrorList(data?: any) {
  return api.post('/common/userTestPapers/errorExerciseIndex', data)
}
/**
 * @param {object} data 传参
 * @description 课程评价
 * @returns {Promise} 请求结果
 */
export function reqCourseEvaluate(data?: any) {
  return api.post('/common/courses/evaluate', data)
}
/**
 * @param {object} data 传参
 * @description 课程评价详情
 * @returns {Promise} 请求结果
 */
export function reqCourseEvaluateDetail(data?: any) {
  return api.post('/common/courses/evaluateDetail', data)
}

// ==================== 云端文件管理相关接口 ====================

/**
 * @param {object} data 传参
 * @description 上传文件到云端
 * @returns {Promise} 请求结果
 */
export function reqCloudFilesUpload(data: any) {
  return api.post('/common/cloudFiles/upload', data, { headers: { 'Content-Type': 'multipart/form-data' } })
}

/**
 * @param {object} data 传参
 * @description 获取云端文件列表
 * @returns {Promise} 请求结果
 */
export function reqCloudFilesList(data?: any) {
  return api.post('/common/cloudFiles/list', data)
}

/**
 * @param {object} data 传参
 * @description 云端文件微调
 * @returns {Promise} 请求结果
 */
export function reqCloudFilesFineTune(data: any) {
  return api.post('/common/cloudFiles/fineTune', data)
}

/**
 * @param {object} data 传参
 * @description 查询云端微调任务状态
 * @returns {Promise} 请求结果
 */
export function reqCloudFilesTaskStatus(data: any) {
  return api.post('/common/cloudFiles/getTaskStatus', data)
}

/**
 * @param {object} data 传参
 * @description 获取云端微调任务列表
 * @returns {Promise} 请求结果
 */
export function reqCloudFilesTaskList(data?: any) {
  return api.post('/common/cloudFiles/getTaskList', data)
}
/**
 * @param {object} data 传参
 * @description 删除评价
 * @returns {Promise} 请求结果
 */
export function reqCourseEvaluateDelete(data?: any) {
  return api.post('/common/courses/deleteEvaluate', data)
}
/**
 * @param {object} data 传参
 * @description 生成课件的api接口
 * @returns {Promise} 请求结果
 */
export function reqCourseApiGenerate(data?: any) {
  return api.post('/teacher/lessonPreparation/apiGenerate', data)
}
/**
 * @param {object} data 传参
 * @description 散点图
 * @returns {Promise} 请求结果
 */
export function reqSnarPlot(data?: any) {
  return api.post('/common/snar/plot', data)
}
/**
 * @param {object} data 传参
 * @description 下载已选化合物文件
 * @returns {Promise} 请求结果
 */
export function reqSnarDownloadFile(data?: any) {
  return api.post('/common/snar/downloadFile', data)
}
/**
 * @param {object} data 传参
 * @description 上传化合物文件
 * @returns {Promise} 请求结果
 */
export function reqSnarUploadFile(data?: any) {
  return api.post('/common/snar/uploadFile', data)
}
/**
 * @param {object} data 传参
 * @description 实验预测
 * @returns {Promise} 请求结果
 */
export function reqSnarPredict(data?: any) {
  return api.post('/common/snar/predict', data)
}
/**
 * @param {object} data 传参
 * @description 条件推荐
 * @returns {Promise} 请求结果
 */
export function reqSnarCondition(data?: any) {
  return api.post('/common/snar/condition', data)
}
/**
 * @param {object} data 传参
 * @description 自动建模工具
 * @returns {Promise} 请求结果
 */
export function reqSnarRunModel(data?: any) {
  return api.post('/common/snar/runModel', data)
}
/**
 * @param {object} data 传参
 * @description 成绩
 * @returns {Promise} 请求结果
 */
export function reqUserTestPapersIndex(data?: any) {
  return api.post('/common/userTestPapers/index', data)
}

// 新增
/**
 * @param {object} data 传参
 * @description 更新知识节点
 * @returns {Promise} 请求结果
 */
export function reqUpdateKnowledgeNode(data?: any) {
  return api.post('/common/courseKnowledge/update', data)
}
/**
 * @param {object} data 传参
 * @description 删除知识节点
 * @returns {Promise} 请求结果
 */
export function reqDeleteKnowledgeNode(data?: any) {
  return api.post('/common/courseKnowledge/delete', data)
}
// 在 @/api/modules/knowledgeBase 中添加新增节点API
export function reqAddKnowledgeNode(data?: any) {
  return api.post('/common/courseKnowledge/add', data)
}
// 在 @/api/modules/knowledgeBase.ts 中添加
/**
 * 新增课程
 * @param {object} data 传参
 * @returns {Promise} 请求结果
 */
export function reqKnowledgeCoursesCreate(data: any) {
  return api.post('/common/courses/create', data)
}

/**
 * 更新课程
 * @param {object} data 传参
 * @returns {Promise} 请求结果
 */
export function reqKnowledgeCoursesUpdate(data: any) {
  return api.post('/common/courses/update', data)
}

/**
 * 删除课程(移至回收站)
 * @param {object} data 传参
 * @returns {Promise} 请求结果
 */
export function reqCoursesDelete(data: any) {
  return api.post('/teacher/courses/delete', data)
}

/**
 * 获取删除课程影响信息
 * @param {object} data 传参
 * @returns {Promise} 请求结果
 */
export function reqCoursesDeleteInfo(data: any) {
  return api.post('/teacher/courses/getDeleteInfo', data)
}

/**
 * 恢复课程
 * @param {object} data 传参
 * @returns {Promise} 请求结果
 */
export function reqCoursesRestore(data: any) {
  return api.post('/teacher/courses/restore', data)
}

/**
 * 永久删除课程
 * @param {object} data 传参
 * @returns {Promise} 请求结果
 */
export function reqCoursesForceDelete(data: any) {
  return api.post('/teacher/courses/forceDelete', data)
}

/**
 * 课程回收站列表
 * @param {object} data 传参
 * @returns {Promise} 请求结果
 */
export function reqCoursesTrashedIndex(data: any) {
  return api.post('/teacher/courses/trashedIndex', data)
}

/**
 * @param {object} data 传参
 * @description 获取删除试卷影响信息
 * @returns {Promise} 请求结果
 */
export function reqTestPaperDeleteInfo(data: any) {
  return api.post('/teacher/courseTestPapers/getDeleteInfo', data)
}

/**
 * @param {object} data 传参
 * @description 级联删除试卷及相关数据
 * @returns {Promise} 请求结果
 */
export function reqTestPaperDeleteWithCascade(data: any) {
  return api.post('/teacher/courseTestPapers/deleteWithCascade', data)
}

/**
 * @param {object} data 传参
 * @description 导出试卷为Excel文件
 * @returns {Promise} 请求结果
 */
export function reqTestPaperExport(data: any) {
  return api.post('/teacher/courseTestPapers/export', data, { responseType: 'blob' })
}

/**
 * @param {object} data 传参
 * @description 更新试卷信息
 * @returns {Promise} 请求结果
 */
export function reqTestPaperUpdate(data: any) {
  return api.post('/teacher/courseTestPapers/update', data)
}

/**
 * @param {object} data 传参
 * @description 恢复试卷
 * @returns {Promise} 请求结果
 */
export function reqTestPaperRestore(data: any) {
  return api.post('/teacher/courseTestPapers/restore', data)
}

/**
 * @param {object} data 传参
 * @description 永久删除试卷
 * @returns {Promise} 请求结果
 */
export function reqTestPaperForceDelete(data: any) {
  return api.post('/teacher/courseTestPapers/forceDelete', data)
}

/**
 * @param {object} data 传参
 * @description 获取回收站列表
 * @returns {Promise} 请求结果
 */
export function reqTestPaperTrashedIndex(data: any) {
  return api.post('/teacher/courseTestPapers/trashedIndex', data)
}

/**
 * @param {object} data 传参
 * @description 教师端试卷列表（包含未发布的）
 * @returns {Promise} 请求结果
 */
export function reqTestPaperTeacherIndex(data: any) {
  return api.post('/teacher/courseTestPapers/teacherIndex', data)
}

/**
 * @param {object} data 传参
 * @description 发布试卷（更新release_status为1）
 * @returns {Promise} 请求结果
 */
export function reqTestPaperPublish(data: any) {
  return api.post('/teacher/courseTestPapers/publish', data)
}

// ==================== 章节管理相关接口 ====================

/**
 * @param {object} data 传参
 * @description 新增章节
 * @returns {Promise} 请求结果
 */
export function reqChapterCreate(data: any) {
  return api.post('/teacher/courseKnowledge/create', data)
}

/**
 * @param {object} data 传参
 * @description 更新章节
 * @returns {Promise} 请求结果
 */
export function reqChapterUpdate(data: any) {
  return api.post('/teacher/courseKnowledge/update', data)
}

/**
 * @param {object} data 传参
 * @description 删除章节（移至回收站）
 * @returns {Promise} 请求结果
 */
export function reqChapterDelete(data: any) {
  return api.post('/teacher/courseKnowledge/delete', data)
}

/**
 * @param {object} data 传参
 * @description 获取删除章节影响信息
 * @returns {Promise} 请求结果
 */
export function reqChapterDeleteInfo(data: any) {
  return api.post('/teacher/courseKnowledge/getDeleteInfo', data)
}

/**
 * @param {object} data 传参
 * @description 恢复章节
 * @returns {Promise} 请求结果
 */
export function reqChapterRestore(data: any) {
  return api.post('/teacher/courseKnowledge/restore', data)
}

/**
 * @param {object} data 传参
 * @description 永久删除章节
 * @returns {Promise} 请求结果
 */
export function reqChapterForceDelete(data: any) {
  return api.post('/teacher/courseKnowledge/forceDelete', data)
}

/**
 * @param {object} data 传参
 * @description 获取章节回收站列表
 * @returns {Promise} 请求结果
 */
export function reqChapterTrashedIndex(data: any) {
  return api.post('/teacher/courseKnowledge/trashedIndex', data)
}

// ==================== 知识点管理相关接口 ====================

/**
 * @param {object} data 传参
 * @description 新增知识点
 * @returns {Promise} 请求结果
 */
export function reqPointCreate(data: any) {
  return api.post('/teacher/courseKnowledgePoints/create', data)
}

/**
 * @param {object} data 传参
 * @description 更新知识点
 * @returns {Promise} 请求结果
 */
export function reqPointUpdate(data: any) {
  return api.post('/teacher/courseKnowledgePoints/update', data)
}

/**
 * @param {object} data 传参
 * @description 删除知识点
 * @returns {Promise} 请求结果
 */
export function reqPointDelete(data: any) {
  return api.post('/teacher/courseKnowledgePoints/delete', data)
}

/**
 * @param {object} data 传参
 * @description 恢复知识点
 * @returns {Promise} 请求结果
 */
export function reqPointRestore(data: any) {
  return api.post('/teacher/courseKnowledgePoints/restore', data)
}

/**
 * @param {object} data 传参
 * @description 永久删除知识点
 * @returns {Promise} 请求结果
 */
export function reqPointForceDelete(data: any) {
  return api.post('/teacher/courseKnowledgePoints/forceDelete', data)
}

/**
 * @param {object} data 传参
 * @description 获取知识点回收站列表
 * @returns {Promise} 请求结果
 */
export function reqPointTrashedIndex(data: any) {
  return api.post('/teacher/courseKnowledgePoints/trashedIndex', data)
}

// ==================== 知识图谱管理相关接口 ====================

/**
 * @param {object} data 传参
 * @description 重新生成知识图谱
 * @returns {Promise} 请求结果
 */
export function reqRegenerateKnowledgeChart(data: any) {
  return api.post('/teacher/courseKnowledgeChart/regenerate', data)
}

// ==================== 课程学生分配相关接口 ====================

/**
 * @param {object} data 传参
 * @description 获取课程已分配的学生列表
 * @returns {Promise} 请求结果
 */
export function reqCourseStudentsList(data: any) {
  return api.post('/teacher/courseStudents/index', data)
}

/**
 * @param {object} data 传参
 * @description 获取可分配的班级列表（包含学生信息）
 * @returns {Promise} 请求结果
 */
export function reqGetClassesWithStudents(data?: any) {
  return api.post('/teacher/courseStudents/getClassesWithStudents', data)
}

/**
 * @param {object} data 传参
 * @description 批量分配学生到课程
 * @returns {Promise} 请求结果
 */
export function reqBatchAssignStudents(data: any) {
  return api.post('/teacher/courseStudents/batchAssign', data)
}

/**
 * @param {object} data 传参
 * @description 批量移除学生
 * @returns {Promise} 请求结果
 */
export function reqBatchRemoveStudents(data: any) {
  return api.post('/teacher/courseStudents/batchRemove', data)
}

